import { Dialog, SxProps } from "@mui/material"
import { ReactElement, ReactNode } from "react"

import { useScreenSize } from "../../hooks/useScreenSize"
import { THEME_BASE_BORDER_RADIUS } from "../../themes/defaultThemeParams"

interface IAppDialogProps {
    children: ReactNode
    isOpen: boolean
    isFullscreen?: boolean
    maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | undefined
    sx?: SxProps
}

/**
 * App level customised dialog. Adds border radius and media query
 * to accommodate mobile device
 */
const AppDialog = ({
    children,
    isOpen,
    maxWidth,
    isFullscreen = false,
    sx = {},
}: IAppDialogProps): ReactElement => {
    const { isMob } = useScreenSize()
    return (
        <Dialog
            open={isOpen}
            fullScreen={isMob || isFullscreen}
            keepMounted={false}
            maxWidth={maxWidth ?? undefined}
            fullWidth
            PaperProps={{
                sx: {
                    padding: isMob ? 1 : 0,
                    borderRadius:
                        isMob || isFullscreen ? 0 : THEME_BASE_BORDER_RADIUS,
                    backgroundImage: "none",
                    backgroundColor: "background.frameBackground",
                    ...sx,
                },
            }}
        >
            {children}
        </Dialog>
    )
}

AppDialog.defaultProps = {
    isFullscreen: false,
    maxWidth: undefined,
    sx: {},
}

export default AppDialog
